import { connect } from "react-redux";
import ChiTietTaiSan from "components/CommonComponent/ChiTietTaiSan";
import { getTaiSan, getLichSuTaiSan } from "actions/TaiSan";

const mapStateToProps = (state) => ({
  loaitaisan: state.loaitaisan,
  taisan: state.taisan,
});

const mapDispatchToProps = (dispatch) => ({
  getTaiSan: (dataSearch) => dispatch(getTaiSan(dataSearch)),
  getLichSuTaiSan: (dataSearch) => dispatch(getLichSuTaiSan(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChiTietTaiSan);
